/**
 * Device-local settings (localStorage: language, reminder switch, column order) are recorded in
 * the operation log (data dictionary §11). The modules that write them have no store; the app
 * installs the writer at start-up.
 */
type LocalSettingLogger = (name: string, value: unknown) => void;

let logger: LocalSettingLogger | null = null;

export function setLocalSettingLogger(next: LocalSettingLogger | null): void {
  logger = next;
}

export function logLocalSetting(name: string, value: unknown): void {
  logger?.(name, value);
}
